"use client";
import * as React from "react";
const SvgSearchFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.44 10.06h-.73l-.25-.24a6 6 0 0 0 1.43-3.87 5.95 5.95 0 1 0-5.94 5.94 6 6 0 0 0 3.87-1.43l.24.25v.73L14.64 16 16 14.64zm-5.5 0a4.1 4.1 0 0 1-4.11-4.11 4.1 4.1 0 0 1 4.12-4.12 4.1 4.1 0 0 1 4.11 4.12 4.1 4.1 0 0 1-4.11 4.11" }));
export {
  SvgSearchFilled as default
};
